import { render, staticRenderFns } from "./Weighter.vue?vue&type=template&id=a556b406&"
import script from "./Weighter.vue?vue&type=script&lang=js&"
export * from "./Weighter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports